<template>
    <v-container pa-0 ma-0 fluid>
        <v-row>
            <v-col cols="12">
                <h1 class="text-center mb-5">{{$t('components.checks.sound.title')}}</h1>

                <div ref="wave" style="width:100%; height:150px"></div>

                <v-row justify="center">
                    <v-autocomplete :items="audioOutputDevices"
                                    class="mb-2 mr-2"
                                    hide-details
                                    item-color="white"
                                    item-text="label"
                                    item-value="deviceId"
                                    :label="$t('components.checks.sound.output_device')"
                                    light
                                    :no-data-text="$t('components.checks.no_devices')"
                                    prepend-inner-icon="mdi-headphones"
                                    solo
                                    :value="selectedAudioOutputDevice"
                                    @change="setAudioOutputDevice($event)"
                                    v-if="permission"
                                    style="max-width: 500px !important;"
                    ></v-autocomplete>
                </v-row>

                <v-row justify="center">
                    <v-col xs="12" sm="12" md="8">
                        <p class="text-center">
                            {{$t('components.checks.sound.instructions')}}
                        </p>
                    </v-col>
                </v-row>

                <v-row justify="center">
                    <v-btn @click="next()" color="primary">{{$t('general.continue')}}</v-btn>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import {configureDevices} from "../../lib/mediaDevices";
    import SiriWave from 'siriwave';
    import {Howl, Howler} from 'howler';
    import {waitForCondition} from "../../lib/rate";

    export default {
        name: "SoundCheck",
        components: {},
        computed: {
            selectedAudioOutputDevice() {
                return this.$store.state.media.audioOutputDevice;
            }
        },
        data() {
            return {
                audioOutputDevices: null,
                permission: true,
                analysisInterval: null,
                sound: null,
                wave: null,
                volume: 0.03
            }
        },
        mounted() {
            this.initTestSound();
            this.getSystemDevices();
        },
        methods: {
            getSystemDevices() {
                navigator.mediaDevices.enumerateDevices()
                    .then((devices) => {
                            this.audioOutputDevices = devices.filter(d => d.kind === 'audiooutput');
                            configureDevices(false, false, true);
                        },
                        () => {
                            this.permission = false;
                        });
            },
            setAudioOutputDevice(val) {
                this.$store.dispatch('media/setAudioOutputDevice', val);
            },
            initTestSound() {
                this.sound = new Howl({
                    src: ['/sounds/audio_test.mp3'],
                    onload: this.onSoundLoaded,
                    loop: true
                });
                this.sound.volume(this.volume);
            },
            onSoundLoaded() {
                this.initSoundWave();
                this.initAudioAnalysis();
                this.sound.play();
            },
            initSoundWave() {
                if (this.wave) {
                    return;
                }
                waitForCondition(() => {
                    return this.$refs.wave && this.$refs.wave.getBoundingClientRect().width > 0;
                }).then(() => {
                    this.wave = new SiriWave({
                        container: this.$refs.wave,
                        width: this.$refs.wave.getBoundingClientRect().width,
                        height: this.$refs.wave.getBoundingClientRect().height,
                        style: 'ios9',
                        autostart: true,
                        speed: 0.2,
                        amplitude: 1,
                    });
                });
            },
            initAudioAnalysis() {
                const analyser = Howler.ctx.createAnalyser();
                Howler.masterGain.connect(analyser);
                //analyser.connect(Howler.ctx.destination);
                analyser.fftSize = 2048;
                let bufferLength = analyser.frequencyBinCount;
                let dataArray = new Uint8Array(bufferLength);
                analyser.getByteTimeDomainData(dataArray);

                this.analysisInterval = setInterval(() => {
                    analyser.getByteTimeDomainData(dataArray);
                    let amp = 0;
                    for (let i = 0; i < dataArray.length; i++) {
                        const loud = 1 - Math.abs(dataArray[i] / 128.0);
                        if (loud > amp) {
                            amp = loud;
                        }
                    }
                    if (this.wave) {
                        const volumeCompensator = 1 / (this.volume || 0.1);
                        this.wave.setAmplitude((amp * 5 * volumeCompensator) + 0.1)
                    }
                }, 800);
            },
            stopAudioAnalysis() {
                clearInterval(this.analysisInterval);
            },
            clearWave() {
                if (this.wave) {
                    this.wave.stop();
                    this.wave = null;
                    this.$refs.wave.innerHTML = null;
                }
            },
            next() {
                this.$router.replace({name: 'JourneyOrientation'});
            }
        },
        beforeDestroy() {
            this.clearWave();
            this.stopAudioAnalysis();
            this.sound.stop();
            this.sound.unload();
        }
    }
</script>

<style scoped>

</style>